import StepRow from './StepRow';
import '../styles/StepsSection.css';

const STEPS = [
  {
    index: '01',
    title: 'Scan Everything At Once',
    body: "Botzo reads TradingView, Business Insider, earnings, breaking news, X and TikTok in parallel. Price action on one screen, sentiment on another, and the same story surfacing in both is what he's actually looking for.",
    visualSrc: '/images/scan-everything.avif',
  },
  {
    index: '02',
    title: 'Score The Narrative',
    body: "Every story that surfaces gets a confidence score built from how many sources carry it, how fast it's spreading and whether the chart agrees. Most never clear the bar, and that's the point.",
    visualSrc: '/images/score-narrative.avif',
  },
  {
    index: '03',
    title: 'Launch On Solana',
    body: 'When a narrative clears the threshold, the token goes live automatically. No proposal, no vote, no one waiting to press the button. The market exists while the story is still moving.',
    visualSrc: '/images/launch-solana.avif',
  },
  {
    index: '04',
    title: 'Show The Receipts',
    body: 'Every launch carries its reasoning: the articles, the posts, the charts and the score. Rejections get published too, so you can see what he turned down and by how much.',
    visualSrc: '/images/show-receipts.avif',
  },
  {
    index: '05',
    title: 'Track What Happened',
    body: "Price, volume, holders and activity for every token he's ever launched, tied back to the narrative that caused it. His record is public whether it's good or not.",
    visualSrc: '/images/track-what-happened.avif',
  },
];

/**
 * Sits after <TheComeback /> in App.jsx — same "section-cover" treatment
 * (see ScrollSections.css) since five rows plus visuals run well past
 * one screen's height.
 */
export default function StepsSection({ zIndex = 3 }) {
  return (
    <section id="how-it-works" className="steps section-cover" style={{ zIndex }}>
      <div className="steps__header">
        <p className="steps__eyebrow">( HOW IT WORKS )</p>
        <h2 className="steps__title">Five Steps, No Hands On Any Of Them</h2>
      </div>

      <div className="steps__list">
        {STEPS.map((step) => (
          <StepRow key={step.index} {...step} />
        ))}
      </div>
    </section>
  );
}